import * as React from 'react';
import './radiobuttoninput.style.css';

export interface TRadioButtonProps {
  name: string;
  children: string;
  value: number;
  className?: string;
  labelStyle?: string;
  isDisabled?: boolean;
  isChecked?: boolean;
  onChange?: (event: any) => void;
}

export const Radiobutton: React.StatelessComponent<TRadioButtonProps> = ({
  name,
  value,
  children,
  onChange,
  isChecked,
  isDisabled,
  labelStyle,
}) => {
  return (
    <div className="radio-container">
      <input
        type="radio"
        className="radio-item"
        value={value}
        id={String(value)}
        name={name}
        onChange={onChange}
        disabled={isDisabled}
        checked={isChecked}
      />
      <label htmlFor={String(value)} className={`radio-text ${labelStyle}`}>
        {children}
      </label>
    </div>
  );
};
